import { BrowserRouter, Route, Routes, useParams } from "react-router-dom";
import { GlobalStyle, IconSprite } from "senf-atomic-design-system";
import { useThemeColor } from "senf-atomic-design-system/src/hooks/useThemeColor";
import "./i18n/i18n";
import { useEffect } from "react";
import AdminPage from "./admin/pages/AdminPage";
import ObjectsPage from "./admin/pages/ObjectsPage";
import ProjectPage from "./admin/pages/ProjectPage.tsx";
import ProjectsPage from "./admin/pages/ProjectsPage";
import ResultsPage from "./admin/pages/ResultsPage";
import AiImageGenerator from "./aiImageGenerator/AiImageGenerator";
import { CreatedImagesProvider } from "./aiImageGenerator/context/CreatedImagesContext";
import LandingPage from "./aiImageGenerator/LandingPage";
import StartImage from "./aiImageGenerator/StartImage";
import ImagesPage from "./pages/ImagesPage";

function AppContent() {
  const customTheme = useThemeColor({ color: "#95e565" });
  const { projectId } = useParams();

  useEffect(() => {
    if (projectId) {
      localStorage.setItem("projectId", projectId);
    }
  }, [projectId]);

  return (
    <>
      <GlobalStyle custom={customTheme} />
      <IconSprite />
      <Routes>
        <Route path="/" element={<LandingPage />} />

        <Route path="/admin" element={<AdminPage />} />
        <Route
          path="/organizations/:organizationId/results"
          element={<ResultsPage />}
        />
        <Route
          path="/organizations/:organizationId"
          element={<ProjectsPage />}
        />
        <Route
          path="/organizations/:organizationId/projects/"
          element={<ProjectsPage />}
        />
        <Route
          path="/organizations/:organizationId/projects/:projectId"
          element={<ProjectPage />}
        />
        <Route
          path="/organizations/:organizationId/projects/:projectId/results"
          element={<ResultsPage />}
        />

        <Route
          path="/:organizationId/projects/:projectId"
          element={<AdminPage />}
        />
        <Route path="/objects" element={<ObjectsPage />} />
        <Route path="/old-images" element={<ImagesPage />} />

        <Route path="/:projectId" element={<StartImage />} />
        <Route path="/:projectId/edit" element={<AiImageGenerator />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <CreatedImagesProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </CreatedImagesProvider>
  );
}

export default App;
